<template>
  <span>
    <base-icon
        class="mr-1 text-green-500"
        name="check"
        size="sm"
        v-if="validated"
      />
       <base-icon
        class="mr-1 text-red-500"
        name="cross"
        size="sm"
        v-else
      />
  </span>
</template>

<script>
export default {
  name: 'icon-pass-validation',
  props: {
    validated: {
      type: Boolean,
      default: false
    }
  }
}
</script>
